import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { Select as SENDER_SELECT } from 'Components/Api/ImpsGuruDMTAPI';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Paper, Hidden } from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { MONEY_TRANSFER_CODE } from 'Components/Helper/Messages';
import BeneficiaryList from './BeneficiaryList';
import { Last10Report } from 'Pages/InnerPages/Report/Last10Report';

import { PrimaryButton } from 'Components/Inputes/CustomButton';
import SearchIcon from 'Components/SvgButtons/SearchIcon';
import AddbeneficiaryIcon from 'Components/SvgButtons/AddbeneficiaryIcon';

import HOCLoader from 'Components/Loader/HOCLoader';
import AutoSubmitMobileForSender from 'Components/Helper/AutoSubmitMobileForSender';
import { useLocation } from 'react-router-dom';
import usePosition from 'Components/Posistion';

const CustomContainer = HOCLoader(Container);

export const SenderSearch = () => {
    const formRef = useRef();
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();
    const { latitude, longitude } = usePosition();

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [addBeneficiary, setAddBeneficiary] = useState('none');
    const [serviceCode, setServiceCode] = useState(MONEY_TRANSFER_CODE);

    const Mobile = location?.state?.Mobile;
    const [senderNo, setSenderNo] = useState('');
    const ActiveDMTName = location?.state?.DMTName;

    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        Name: '',
        SenderID: '',
        RemainingLimit: '',
        Consumed: '',
        isAddBeneficiary: false,
        Latitude: latitude,
        Longitude: longitude
    });

    useEffect(() => {
        select();
        setLoading(false);
        fetchSender();
        setFormObject((prev) => ({
            ...prev,
            Name: formObject.Name || ''
        }));
    }, [ActiveDMTName]);
    const fetchSender = () => {
        if (formRef === undefined) return;

        if (!formRef.current) return;

        if (formRef.current.values === undefined) return;

        if (formRef.current.values.Mobile === undefined) return;

        if (formRef.current.values.Mobile.length !== 10) return;

        formRef.current.handleSubmit();
    };
    const select = async () => {
        let primaryID = Mobile;
        let senderName = formObject.Name;
        if (primaryID === undefined) return;
        if (primaryID === null) return;
        if (primaryID === 'DMT') return;

        if (primaryID.length !== 10) return;

        let ActiveDMT = ActiveDMTName;
        if (ActiveDMT === undefined) return;
        if (ActiveDMT === null) return;
        if (ActiveDMT === '') return;

        if (senderName === undefined || senderName === '') {
            return;
        }

        setFormObject({
            ...formObject,
            Mobile: Mobile,
            Name: senderName,
            SenderID: '',
            RemainingLimit: '',
            Consumed: ''
        });
    };

    const submitHandle = async (values, { setSubmitting, resetForm }) => {
        setFormObject({
            ...formObject,
            Mobile: values.Mobile,
            Name: values.Name,
            SenderID: '',
            Consumed: '',
            RemainingLimit: ''
        });
        setServiceCode('');
        setSenderNo('');
        setResponseMessage('');
        values.DMTName = ActiveDMTName;
        values.Latitude = latitude;
        values.Longitude = longitude;
        var requestObj = JSON.stringify(values);

        //setLoading(true);
        setIsError(false);

        if (values.isAddBeneficiary) {
            var param = {
                Mobile: values.Mobile,
                SenderID: values.SenderID,
                SenderName: values.Name,
                DMTName: ActiveDMTName
            };
            history.push('/IG_BeneAdd', param);
            return;
        }
        setLoading(true);

        var response = await SENDER_SELECT(requestObj);

        if (!response.isAuthorized) LOGOUT();
        setIsError(true);
        setResponseMessage(response.Message);
        setServiceCode(MONEY_TRANSFER_CODE);
        setSeverity('success');

        var data = JSON.parse(response.data);

        let paramSender = {
            DMTName: ActiveDMTName,
            Mobile: values.Mobile,
            State: data.Data
        };

        if (data.Message === 'OTP sent on mobile number') {
            setResponseMessage(data.Message);
            setSeverity('success');
            history.push('/IG_SenderAdd', paramSender);
            return;
        }

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            var data = JSON.parse(response.data);
            if (
                data.Message ===
                'Your KYC is not approved, please contact to customer care'
            ) {
                history.push('/KYC/Upload');
                return;
            }
            setLoading(false);
            return;
        }

        var data = JSON.parse(response.data);

        setAddBeneficiary('inline');

        setFormObject({
            Mobile: data.Mobile,
            SenderID: data.SenderID,
            Name: values.Name,
            Consumed: `Bank1:${data.ComsumedLimit1},  Bank2:${data.ComsumedLimit2}`,
            //RemainingLimit: `Bank1:${data.RemainingLimit1},  Bank2:${data.RemainingLimit2}`,
            RemainingLimit: data.RemainingLimit,
            isAddBeneficiary: false,
            DMTName: ActiveDMTName
        });

        setSenderNo(data.Mobile);
        //setLoading(false);
    };

    const FormValidationSchema = Yup.object({});

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submitHandle}
                resetForm={formObject}
            >
                {({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <AutoSubmitMobileForSender />
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={8} sm={8} md={2} lg={2}>
                                            <MaterialTextField
                                                label="Name"
                                                name="Name"
                                                type="text"
                                                placeholder="Name"
                                            />
                                        </Grid>
                                        <Grid item xs={8} sm={8} md={2} lg={2}>
                                            <MaterialNumberField
                                                label="Mobile"
                                                name="Mobile"
                                                type="Mobile"
                                                length={10}
                                                typed_length={1}
                                                placeholder="Mobile"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                title="Search"
                                                disabled={loading}
                                                endIcon={<SearchIcon />}
                                                onClick={(e) => {
                                                    setFieldValue(
                                                        'isAddBeneficiary',
                                                        false
                                                    );
                                                    setAddBeneficiary('none');
                                                    handleSubmit(e);
                                                }}
                                            >
                                                Search
                                            </PrimaryButton>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <Box display={addBeneficiary}>
                                                <PrimaryButton
                                                    title="Add Beneficiary"
                                                    disabled={loading}
                                                    endIcon={
                                                        <AddbeneficiaryIcon />
                                                    }
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddBeneficiary',
                                                            true
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                >
                                                    Add Beneficiary
                                                </PrimaryButton>
                                            </Box>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        ></Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Name"
                                                name="Name"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Name"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Remaining Limit"
                                                name="RemainingLimit"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Remaining Limit"
                                            />
                                            <Hidden xsUp>
                                                <MaterialTextField
                                                    label="SenderID"
                                                    name="SenderID"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="SenderID"
                                                />
                                            </Hidden>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Consumed"
                                                name="Consumed"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Consumed"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>

            <BeneficiaryList
                senderNo={senderNo}
                ActiveDMTName={ActiveDMTName}
                senderName={formObject.Name}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />

            <Last10Report
                ServiceID={serviceCode}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />
        </CustomContainer>
    );
};
